import { Controller } from "@hotwired/stimulus";

// Email marketing campaign calendar navigation. The grid is rendered server-side;
// this controller just swaps in the grid for the month/week the flatpickr pickers
// (or their chevrons) select. Tooltips and the preview modal are wired in the
// server-rendered partial, so there's nothing to manage here.
export default class extends Controller {
  static targets = ["grid"];
  static values = { url: String };

  // Fired by `flatpickr:dateChange` from either picker (month or day).
  navigate(event) {
    const date = event.detail.date;
    const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
      date.getDate()
    ).padStart(2, "0")}`;

    fetch(`${this.urlValue}?date=${key}`, { headers: { Accept: "text/html" } })
      .then((response) => response.text())
      .then((html) => {
        this.gridTarget.innerHTML = html;
      })
      .catch((error) => console.error("Calendar navigation failed", error));
  }
}
